import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pt-4" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[12] || (_cache[12] = _createElementVNode("h3", null, "購入履歴", -1)),
    _createVNode(_component_v_card, {
      color: "grey-lighten-5",
      class: "mt-2",
      variant: "flat"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createElementVNode("h5", null, "クラス", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.classId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilters.classId) = $event)),
                      items: _ctx.classes,
                      "item-title": "className",
                      "item-value": "classId",
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: ""
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[6] || (_cache[6] = _createElementVNode("h5", null, "シリアル番号", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchFilters.serialNumber,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilters.serialNumber) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: "",
                      type: "number"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createElementVNode("h5", null, "販売種別", -1)),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.searchFilters.mediaFormat,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFilters.mediaFormat) = $event)),
                      items: _ctx.mediaFormatType,
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      clearable: ""
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[8] || (_cache[8] = _createElementVNode("h5", null, "購入期間開始日", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchFilters.from,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFilters.from) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      type: "date",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _cache[9] || (_cache[9] = _createElementVNode("h5", null, "購入期間終了日", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.searchFilters.to,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFilters.to) = $event)),
                      variant: "outlined",
                      density: "compact",
                      "hide-details": "",
                      type: "date",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, { cols: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.searchHistory,
                      loading: _ctx.loading,
                      color: "primary",
                      variant: "flat",
                      block: ""
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("検索", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_table, null, {
        default: _withCtx(() => [
          _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "ID"),
              _createElementVNode("th", null, "購入日時"),
              _createElementVNode("th", null, "販売種別"),
              _createElementVNode("th", null, "カテゴリ"),
              _createElementVNode("th", null, "撮影日"),
              _createElementVNode("th", null, "単価"),
              _createElementVNode("th", null, "個数"),
              _createElementVNode("th", null, "売上"),
              _createElementVNode("th", null, "クラス")
            ])
          ], -1)),
          (_ctx.purchaseHistory)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseHistory.data, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(item.multiMedia.serialNumber), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.purchasedAt)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.mediaFormat
                  ? _ctx.mediaFormatType.find((m) => m.value == item.mediaFormat)?.title ?? ""
                  : ""), 1),
                    _createElementVNode("td", null, _toDisplayString(item.multiMedia.category
                  ? _ctx.multimediaCategoryType.find(
                      (m) => m.value == item.multiMedia.category
                    )?.title ?? ""
                  : ""), 1),
                    _createElementVNode("td", null, _toDisplayString(item.multiMedia.date), 1),
                    _createElementVNode("td", null, _toDisplayString(`${item.multiMedia.price}円`), 1),
                    _createElementVNode("td", null, _toDisplayString(`${item.multiMedia.purchasedCount}`), 1),
                    _createElementVNode("td", null, _toDisplayString(`${item.multiMedia.revenue}円`), 1),
                    _createElementVNode("td", null, _toDisplayString(item.nurseryClasses
                  ? item.nurseryClasses.map((c) => c.className).join(",")
                  : ""), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}